import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { useContext, useEffect } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
// import { makeStyles } from "@material-ui/core";
import { Document, Page } from "react-pdf";
import { useState } from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  textarea: {
    resize: "both",
  },
  heading: {
    fontSize: "16px",
    fontWeight: 500,
    width: "100%",
    textAlign: "left",
    color: process.env.REACT_APP_COLOR_ACCORDION,
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      minWidth: "120vh",

      borderRadius: "14px",
    },
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogPaper: {
    borderRadius: "20px",
  },
}));
function ViewNDA(props) {
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });

  const handleClose = () => {
    props.onClose(false);
  };

  const [numPages, setNumPages] = useState(null);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <>
      <Dialog
        hideBackdrop
        aria-labelledby="form-dialog-title"
        className={classes.dialogbox}
        open={props.open}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle
          id="form-dialog-title"
          variant="h4"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            position: "sticky",
            top: 0,
            zIndex: 10,
            color: darkMode ? "#fff" : "#000",
            fontSize: "21px",
          }}
        >
          <IconButton
            onClick={handleClose}
            aria-label="close"
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
            marginTop: "10px",
          }}
        />

        <DialogContent>
          <Document file={props.document} onLoadSuccess={onDocumentLoadSuccess}>
            {[...Array(numPages)].map((_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={1.5}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                className="pdf-page"
              />
            ))}
          </Document>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ViewNDA;
